import { render } from "./credit-notes-draft.vue?vue&type=template&id=7cd6e970"
import script from "./credit-notes-draft.vue?vue&type=script&lang=js"
export * from "./credit-notes-draft.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__